import { defineMessages } from 'react-intl';

export const consentLanguage = defineMessages({
  withdrawingConsent: {
    id: 'consentLanguage.withdrawingConsent',
    defaultMessage: 'Withdrawing Consent',
  },
  withdrawingConsent2: {
    id: 'consentLanguage.withdrawingConsent2',
    defaultMessage:
      'YOU CAN WITHDRAW YOUR CONSENT FOR OUR USE OF YOUR PII OR PHI INACTIVITIES THAT HAVE NOT BEGAN AS OF THE DATE YOU WITHDRAW YOUR CONSENT, BUT YOU CANNOT WITHDRAW YOUR CONSENT FOR OUR USE OF THAT INFORMATION FOR ACTIVITIES AND PURPOSES THAT BEGAN BEFORE THE DATE ON WHICH YOU WITHDREW YOUR CONSENT, OR WHERE OUR USE OR DISCLOSURE OF THAT INFORMATION IS AUTHORIZED OR REQUIRED BY LAW',
  },
  afterTickConsent: {
    id: 'consentLanguage.afterTickConsent',
    defaultMessage:
      'If at any time you wish to withdraw your consent to any of the above options, you may untick the box beside that item in the Consent settings within Engage or by contacting VITALL Support at 1-800-400-0361 or support@vitall.com.',
  },
  mandatoryConsent: {
    id: 'consentVitallForm.mandatoryConsent',
    defaultMessage:
      'This consent is mandatory in order to receive services from VITALL.',
  },
  mandatoryConsents: {
    id: 'consentLanguage.mandatoryConsents',
    defaultMessage:
      'These consents are mandatory in order to receive services from VITALL.',
  },
  submit: {
    id: 'GLOBAL.submit',
    defaultMessage: 'Submit',
  },
});
